import React from "react";
import { Helmet } from 'react-helmet';
import Navbar from "../components/Navbar";
import Breadcrumb from "../components/Breadcrumb";
import ContactDetails from "../components/ContactDetails";
import Footer from "../components/Footer";

const Contact = () => {
    return (
        <>
            <Helmet>
                <title>Contact Us | ConnectUs Infoway Pvt. Ltd.</title>
            </Helmet>
            <Navbar />
            <Breadcrumb title="CONTACT" />
            <ContactDetails />
            <Footer />
        </>
    );
}

export default Contact;
